import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Delete orchid pro appointment series
 *
 */
export default async function deleteAppointmentSeries(
  appointmentSeriesId,
  firstIdToDelete,
) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/appointment/series/${appointmentSeriesId}`,
    {
      body: JSON.stringify({
        cancel_from_appointment_id: firstIdToDelete,
      }),
      method: "DELETE",
    },
  );
  if (!res.ok) {
    throw new Error(
      `failed to delete appointment series: ${getErrorDetail(
        await res.text(),
      )}`,
    );
  }
  return res.json();
}
